import ViewportWatcher from '../../_lib/viewport-watcher';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

export default class ScrollGrow {
  scrollGrowImages: NodeListOf<Element>;
  ViewportWatcher: ViewportWatcher;
  scrollGrowTimelines: any;

  constructor() {
    this.scrollGrowImages = document.querySelectorAll('.scroll-grow');
    if (this.scrollGrowImages.length < 1) return;

    this.ViewportWatcher = new ViewportWatcher();
    this.scrollGrowTimelines = Object.create({});

    document.addEventListener("DOMContentLoaded", () => {
      if (this.ViewportWatcher.viewMode === 'standard') this.initScrollTrigger()
      this.initResizeWatcher();
    })
  }

  initResizeWatcher() {
    window.addEventListener('viewport:resized-to:mobile', () => {
      this.destroyScrollTrigger()
    });
    window.addEventListener('viewport:resized-to:standard', () => {
      this.initScrollTrigger()
    });
  }

  initScrollTrigger() {
    this.scrollGrowImages.forEach((image, index) => {
      let scalingFactor = ('scalingFactor' in image.dataset)? parseFloat(image.dataset.scalingFactor) : 1.3;

      this.scrollGrowTimelines[index] = gsap.timeline({
        scrollTrigger: {
          trigger: image,
          start: "top 80%",
          end: "bottom top",
          toggleActions: "play none none reverse",
          scrub: true
        }
      });
      this.scrollGrowTimelines[index].fromTo(image, { scale: 1 }, { scale: scalingFactor })
    })
  }

  destroyScrollTrigger() {
    this.scrollGrowImages.forEach((image, index) => {
      this.scrollGrowTimelines[index].seek(0);
      this.scrollGrowTimelines[index].kill();
    })
    this.scrollGrowTimelines = Object.create({});
  }
}
